import React from 'react'

const DashDispatchsNew = () => {
  return (
    <div>DashDispatchsNew</div>
  )
}

export default DashDispatchsNew